import React, { useState, useEffect } from "react";

import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import { fetchwishlist ,removewislist}  from '../../../ApiService/addtowishlist/addtowishlist' // ✅ your fetch API


const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;

export default function Wishlist() {
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const customer_id = localStorage.getItem("customer_id");

  useEffect(() => {
    if (customer_id) {
      loadWishlist();
    } else {
      setError("Please log in to view your wishlist.");
      setLoading(false);
    }
  }, [customer_id]);

  // ✅ Fetch wishlist data
  const loadWishlist = async () => {
    try {
      setLoading(true);
      const data = await fetchwishlist(customer_id);

      // Adjust this based on your API response structure
      const items = Array.isArray(data)
        ? data
        : Array.isArray(data?.wishlist_items)
        ? data.wishlist_items
        : [];

      setWishlistItems(items);
    } catch (err) {
      console.error("Error fetching wishlist:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Remove wishlist item
  const handleRemove = async (sku_code) => {
    try {
      await removewislist(customer_id, sku_code);
      setWishlistItems((prev) =>
        prev.filter((item) => item.variant?.sizes?.[0]?.sku !== sku_code)
      );
    } catch (error) {
      console.error("Error removing item:", error);
      alert("Failed to remove item from wishlist");
    }
  };

  if (loading) return <p className="text-center pt-20">Loading wishlist...</p>;
  if (error) return <p className="text-center pt-20 text-red-500">{error}</p>;

  return (
    <>
      <Navbar />
      <div className="container mx-auto pt-24 pb-16">
        <h2 className="text-2xl font-bold mb-6">My Wishlist</h2>

        {!wishlistItems || wishlistItems.length === 0 ? (
          <p>Your wishlist is empty.</p>
        ) : (
          <div className="grid gap-4">
            {wishlistItems.map((item, index) => {
              const variant = item.variant || {};
              const firstImage = variant.images?.[0]
                ? `${BASE_MEDIA_URL}${variant.images[0]}`
                : "";

              const price =
                variant?.sizes?.[0]?.price?.discounted ||
                variant?.sizes?.[0]?.price?.mrp ||
                0;
              const size = variant?.sizes?.[0]?.size || "N/A";
              const sku_code = variant?.sizes?.[0]?.sku || "";
              const gender =
                variant?.gender === "Men"
                  ? "M"
                  : variant?.gender === "Women"
                  ? "F"
                  : variant?.gender;
              const fabric = variant?.fabric || "N/A";

              return (
                <div
                  key={index}
                  className="flex items-center justify-between border p-4 rounded-lg shadow-sm"
                >
                  <div className="flex items-center gap-4">
                    <img
                      src={firstImage}
                      alt={item.product_name}
                      className="w-20 h-20 object-cover rounded-md"
                    />
                    <div>
                      <h3 className="font-semibold">{item.product_name}</h3>
                      <p className="text-sm text-gray-500">
                        Brand: <span className="font-medium">{item.brand_name}</span>
                      </p>
                      <div className="flex items-center gap-2 text-sm text-gray-500 mt-1">
                        <span>Color:</span>
                        <span
                          className="inline-block w-5 h-5 rounded-full border border-gray-300"
                          style={{ backgroundColor: variant.color_code }}
                        ></span>
                        <span className="font-medium">{variant.color}</span>
                      </div>
                      <p className="text-sm text-gray-500">
                        Size: <span className="font-medium">{size}</span>
                      </p>
                      <p className="text-sm text-gray-500">
                        Gender: <span className="font-medium">{gender}</span>
                      </p>
                      <p className="text-sm text-gray-500">
                        Fabric: <span className="font-medium">{fabric}</span>
                      </p>
                      <p className="text-gray-800 font-semibold">
                        Price: ₹{price.toLocaleString()}
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col items-end gap-2">
                    {/* ✅ Remove button */}
                    <button
                      onClick={() => handleRemove(sku_code)}
                      className="text-red-500 font-medium hover:text-red-700 transition"
                    >
                      Remove
                    </button>

                 
                 
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
